import { render, staticRenderFns } from "./lineTendencias.vue?vue&type=template&id=f3552232&"
import script from "./lineTendencias.vue?vue&type=script&lang=js&"
export * from "./lineTendencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports